import * as admin from "./admin";
import * as auth from "./auth";
import * as billing from "./billing";
import * as clips from "./clips";
import * as customVocabulary from "./customVocabulary";
import * as dailyRead from "./dailyRead";
import * as eventGroups from "./eventGroups";
import integrations from "./integrations";
import * as integrationSettings from "./integrationSettings";
import * as schedulingLinks from "./schedulingLinks";
import * as serviceStatus from "./serviceStatus";
import session from "./session";
import * as sessions from "./sessions";
import * as tags from "./tags";
import * as topics from "./topics";
import workspace from "./workspace";

export default {
  admin,
  auth,
  billing,
  clips,
  customVocabulary,
  dailyRead,
  eventGroups,
  integrations,
  integrationSettings,
  schedulingLinks,
  session,
  sessions,
  tags,
  topics,
  workspace,
  serviceStatus,
};
